// src/unicodex_ui/pages/DocsPage.jsx
import React from "react";
import "../styles/DocsPage.css";
import TopNav from "../components/TopNav";
import FooterBar from "../components/FooterBar";

function DocsPage() {
  return (
    <div className="ucx-body">
      <TopNav />

      <main className="ucx-main">
        <section className="ucx-section">
          <div className="ucx-container ucx-max-700">
            <h1>UNI-CODEX Technical Documentation</h1>
            <p>
              This area will host implementation guides, API references, and
              compliance documentation as the platform progresses.
            </p>
            <p className="ucx-muted">
              More to be uploaded
            </p>
          </div>
        </section>
      </main>

      <FooterBar />
    </div>
  );
}

export default DocsPage;
